import { cx } from '@libs/classnames';
import { MdText } from '@ui/components/MdText';

import { NewsPost } from '@features/shared/api/typings';

import styles from './NewsPostCard.module.css';

type Props = {
  className?: string;
  newsPost: NewsPost;
};
export function NewsPostCard({ className, newsPost }: Props) {
  return (
    <div className={cx(styles.newsPost, className)}>
      <div className={styles.title}>{newsPost.title}</div>
      <div className={styles.description}>
        <MdText value={newsPost.text} />
      </div>
    </div>
  );
}
